module.exports = __webpack_public_path__ + "d204c9acec511b17ad8a3c37908c270c.jpg";